module.exports = __webpack_public_path__ + "img/ob-1.2ac4b55c.webp";